import { useWizard } from "react-use-wizard";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";
import buySteps from "../buySteps";

const SureStepBuy_2 = () => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.sureSteps.step_1);
  };

  const handleNextStep = () => {
    goToStep(buySteps.sureSteps.step_3);
  };

  return (
    <div>
      <BaseStep
        prevStep={handlePrevStep}
        nextStep={handleNextStep}
        text="Нажимая 'Далее >' подтверждаю стоимость работы риелтора 2.5%"
      />
    </div>
  );
};

export default SureStepBuy_2;
